import { render, staticRenderFns } from "./committeeIndex.vue?vue&type=template&id=4f84b1fe&scoped=true"
import script from "./committeeIndex.vue?vue&type=script&lang=js"
export * from "./committeeIndex.vue?vue&type=script&lang=js"
import style0 from "./committeeIndex.vue?vue&type=style&index=0&id=4f84b1fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_7d97cc52897b1b5edd1ee8818c6a75fc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f84b1fe",
  null
  
)

export default component.exports